import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchVehiclesAvailability = (params = {}, limit = 20, page = 0) => {
  const itemsCount = `&limit=${limit}`;
  const offset = `&offset=${page * limit}`;

  return apiActionCreator({
    'endpoint': `/quality-assurance/vehicles-availability${getUrlParameters(params)}${itemsCount}${offset}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_VEHICLES_AVAILABILITY,
      ActionTypes.FETCHED_VEHICLES_AVAILABILITY,
      [ActionTypes.FETCHED_VEHICLES_AVAILABILITY_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchOrdersByChassis = (chassis, params = {}) => {
  return apiActionCreator({
    'endpoint': `/accessories/chassis/${chassis}/orders${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ORDERS_BY_CHASSIS,
      ActionTypes.FETCHED_ORDERS_BY_CHASSIS,
      [ActionTypes.FETCHED_ORDERS_BY_CHASSIS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const updateAvailabilityInVehicle = (chassis, data = {}) => apiActionCreator({
  'endpoint': `/quality-assurance/vehicles-availability/chassis/${chassis}/availability`,
  'authenticated': true,
  'types': [
    ActionTypes.UPDATING_AVAILABILITY_IN_VEHICLE,
    [
      ActionTypes.UPDATED_AVAILABILITY_IN_VEHICLE,
      MessageActions.addMessageBoxInfo(`El chassis ${chassis} ha sido actualizado satisfactoriamente`),
    ],
    [ActionTypes.UPDATED_AVAILABILITY_IN_VEHICLE_FAILED, (error) => buildErrorMessage(error)],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  data,
});
